import React from 'react'
import { useStyles } from './InterruptionStyle'

//Material UI
import Card from '@material-ui/core/Card'

export default function Interruption({ message }) {

  const classes = useStyles()


  return (
    <div className={classes.root} >
      <Card className={classes.card}>
        <h2 className={classes.title}>Interruption</h2>
        <div className={classes.cont}>
          <div className={classes.message}>{message}</div>
        </div>
      </Card>
    </div >
  )
}
